<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="860px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div v-if="type === 'view' && stockTakingReport.receipt_number">
      <el-link @click="openReceipt" type="primary" style="margin-bottom: 30px; margin-top: -20px;">
        <i class="el-icon-printer el-icon--right"></i>
        {{ stockTakingReport.receipt_number }}
      </el-link>
    </div>
    <div v-loading="loading">
      <el-tabs
        v-model="selectedTab"
        tab-position="top"
      >
        <el-tab-pane
          label="Ütemterv"
          name="basicData"
        >
          <basic-data-form
            v-if="stockTakingReport"
            ref="basicData"
            :stockTakingReport="stockTakingReport"
            :default="defaultBasicData"
            :dialog-type="type"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Tagok"
          name="members"
        >
          <member-form
            v-if="stockTakingReport"
            ref="memberForm"
            :members="stockTakingReport.members"
            :dialog-type="type"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Leltározási utasítás"
          name="instructions"
        >
          <instruction-form
            v-if="stockTakingReport"
            ref="stockTakingInstructions"
            :dialog-type="type"
            :stockTakingReport="stockTakingReport"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Leltározási adatok"
          name="stockTakingData"
        >
          <el-tabs
            v-model="selectedDataTab"
            tab-position="top"
          >
            <el-tab-pane
              label="Leltárkülönbözet"
              name="stockTakingDiff"
            >
              <el-tabs
                v-model="selectedStockTakingDiffTab"
                tab-position="top"
              >
                <el-tab-pane
                  label="Leltárak"
                  name="stockTakings"
                >
                  <stock-taking-form
                    v-if="stockTakingReport"
                    ref="stockTakingForm"
                    :report-stock-takings="stockTakingReport.stock_takings"
                    :dialog-type="type"
                    @selectedStockTakingsChange="onStockTakingsChange"
                  />
                </el-tab-pane>
                <el-tab-pane
                  v-if="diffLoading || stockTakingLack.length"
                  label="Hiány"
                  name="lack"
                >
                  <stock-taking-lack-form
                    v-loading="diffLoading"
                    :stock-taking-lack="stockTakingLack"
                  />
                </el-tab-pane>
                <el-tab-pane
                  v-if="diffLoading || stockTakingPlus.length"
                  label="Többlet"
                  name="plus"
                >
                  <stock-taking-plus-form
                    v-loading="diffLoading"
                    :stock-taking-plus="stockTakingPlus"
                  />
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane
              label="Adatok"
              name="data"
            >
              <data-form
                v-if="stockTakingReport"
                ref="dataForm"
                :dialog-type="type"
                :stock-taking-report="stockTakingReport"
              />
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane
          v-if="stockTakingReport.id"
          label="Bizonylatok"
          name="stock_taking_list"
        >
          <stock-taking-list
            ref="stockTakingList"
            :stock-takings="stockTakingReport.stock_takings"
            :dialog-type="type"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      v-if="type !== 'view'"
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import BasicDataForm from './forms/BasicData';
  import MemberForm from './forms/MembersForm';
  import InstructionForm from './forms/StockTakingInstruction';
  import DataForm from './forms/DataForm';
  import StockTakingForm from './forms/StockTakingsForm';
  import StockTakingLackForm from './forms/StockTakingLack';
  import StockTakingPlusForm from './forms/StockTakingPlus';
  import StockTakingList from "./forms/StockTakingList";

  export default {
    components: {
      BasicDataForm,
      MemberForm,
      InstructionForm,
      DataForm,
      StockTakingForm,
      StockTakingLackForm,
      StockTakingPlusForm,
      StockTakingList
    },
    props: ['type', 'stockTakingReportId'],
    data() {
      return {
        loading: false,
        diffLoading: false,
        buttonLoading: false,
        stockTakingReport: {},
        selectedTab: 'basicData',
        selectedDataTab: 'data',
        selectedStockTakingDiffTab: 'stockTakings',
        stockTakingLack: [],
        stockTakingPlus: [],
        defaultBasicData: {
          stockStartDate: '',
          stockCompletedDate: '',
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új leltár jegyzőkönyv';
        } else if (this.type === 'update') {
          return 'Leltár jegyzőkönyv módosítása';
        } else if (this.type === 'view') {
          return 'Leltár jegyzőkönyv megtekintése';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('user/fetchAll'),
        this.$store.dispatch('storage/fetchAll')
      ]);
      if (this.stockTakingReportId) {
        this.stockTakingReport = await this.$store.dispatch('stockTakingReport/fetch', this.stockTakingReportId);
      }
      this.loading = false;
    },
    methods: {
      handleClose() {
        if(this.type === 'view') {
          return this.$router.replace('/processes/stock-takings/stock-taking-reports');
        }
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/processes/stock-takings/stock-taking-reports');
        })
        .catch(() => {
        });
      },

      async store() {
        this.$refs['basicData'].$refs['basicDataForm'].validate(async valid => {
          if (valid) {
            this.$refs['stockTakingInstructions'].$refs['instructionForm'].validate(async valid => {
              if (valid) {
                this.$refs['dataForm'].$refs['dataForm'].validate(async valid => {
                  if (valid) {
                    if (this.$refs['stockTakingForm'].selectedStockTakings.length) {
                      if (this.$refs['memberForm'].isAllFormFieldValid()) {
                        const data = {
                          ...this.$refs['basicData'].basicData,
                          ...this.$refs['stockTakingInstructions'].stockTakingInstruction,
                          ...this.$refs['dataForm'].stockTakingData,
                          stock_takings: [
                            ...this.$refs['stockTakingForm'].selectedStockTakings
                          ],
                          members: [
                            ...this.$refs['memberForm'].committeeMembers,
                            ...this.$refs['memberForm'].stockTakingMembers
                          ]
                        };
                        this.buttonLoading = true;
                        try {
                          if (this.type === 'add') {
                            await this.$store.dispatch('stockTakingReport/create', data);
                          } else if (this.type === 'update') {
                            await this.$store.dispatch('stockTakingReport/update', data);
                          }
                          this.$store.dispatch('stockTakingReport/fetchAll');
                          this.buttonLoading = false;
                          this.$router.replace('/processes/stock-takings/stock-taking-reports');
                        } catch (e) {
                        }
                        this.buttonLoading = false;
                      } else {
                        this.selectedTab = 'members';
                      }
                    } else {
                      this.$messageWrapper.warning('Leltár kiválasztása kötelező');
                      this.selectedTab = 'stockTakingData';
                      this.selectedDataTab = 'stockTakingDiff';
                      this.selectedStockTakingDiffTab = 'stockTakings';
                    }
                  } else {
                    this.selectedTab = 'stockTakingData';
                    this.selectedDataTab = 'data';
                  }
                });
              } else {
                this.selectedTab = 'instructions';
              }
            });
          } else {
            this.selectedTab = 'basicData';
          }
        });
      },
      async onStockTakingsChange(ids) {
        const data = {
          stock_taking_ids: ids
        };
        this.diffLoading = true;
        let differences = await axios.post('api/stock-taking-reports/differences', data);
        this.stockTakingLack = differences.lack;
        this.stockTakingPlus = differences.plus;
        this.defaultBasicData['stockStartDate'] = differences.start_date;
        this.defaultBasicData['stockCompletedDate'] = differences.completed_date;
        this.diffLoading = false;
      },
      openReceipt() {
        if (this.stockTakingReport.receipt_file && this.stockTakingReport.receipt_file.path) {
          window.open(this.stockTakingReport.receipt_file.path);
        }
      },
    },
  };
</script>

